import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ServicesIcon({ className }: IconProps) {
  return (
    <svg
      width="83"
      height="92"
      viewBox="0 0 83 92"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1533)">
        <path
          d="M54.417 33.0092L73.7712 13.5011C65.4972 5.16133 54.0988 0 41.4854 0V27.6146C46.5192 27.6146 51.0901 29.6849 54.3881 33.0092"
          fill="#EAEDF8"
        />
        <path
          d="M41.4854 64.4146C36.4516 64.4146 31.8807 62.3443 28.5826 59.02L9.22852 78.5281C17.5025 86.8679 28.9009 92 41.5143 92C54.1278 92 65.5262 86.8387 73.8001 78.5281L54.446 59.02C51.148 62.3443 46.5771 64.4146 41.5433 64.4146"
          fill="#EAEDF8"
        />
        <path
          d="M24.9087 46.0146C24.9087 36.7709 32.3437 29.2767 41.5145 29.2767V4.16992C18.573 4.16992 0 22.9198 0 46.0146C0 57.562 4.65772 68.0305 12.1506 75.5829L29.7689 57.8244C26.7602 54.7918 24.9087 50.6219 24.9087 45.9855"
          fill="#00C4B3"
        />
        <path
          d="M70.8498 16.4463L53.2314 34.2048C56.2402 37.2374 58.0917 41.4073 58.0917 46.0438C58.0917 50.6802 56.2402 54.8501 53.2314 57.8827L70.8498 75.6412C78.3716 68.0596 83.0004 57.6203 83.0004 46.0729C83.0004 34.5255 78.3426 24.0571 70.8498 16.5046"
          fill="#00416B"
        />
        <path
          d="M53.2313 34.1756L70.8496 16.4172C63.3278 8.83553 52.9709 4.16992 41.5146 4.16992V29.2767C46.0856 29.2767 50.2515 31.143 53.2602 34.1756"
          fill="#EAEDF8"
        />
        <path
          d="M41.486 62.7234C36.915 62.7234 32.7491 60.8571 29.7404 57.8245L12.1221 75.5829C19.6439 83.1646 30.0008 87.8302 41.457 87.8302C52.9133 87.8302 63.2991 83.1354 70.792 75.5829L53.1736 57.8245C50.1649 60.8571 46.028 62.7234 41.4281 62.7234"
          fill="#EAEDF8"
        />
        <path
          d="M62.2287 46.0147C62.2287 34.4673 52.9422 25.1069 41.4859 25.1069C30.0297 25.1069 20.7432 34.4673 20.7432 46.0147C20.7432 57.5621 30.0297 66.9225 41.4859 66.9225C52.9422 66.9225 62.2287 57.5621 62.2287 46.0147Z"
          fill="#FAFBFD"
        />
        <path
          d="M56.1531 46.073C56.1241 42.1947 54.5909 38.5497 51.8714 35.8086C49.0942 33.0092 45.4201 31.4929 41.5145 31.4929C37.609 31.4929 33.9349 33.0384 31.1576 35.8086C28.3803 38.608 26.876 42.3113 26.876 46.2479C26.876 50.1845 28.4093 53.8879 31.1576 56.6872C33.8481 59.3991 37.4354 60.9154 41.2252 61.0029H41.5145C45.4201 61.0029 49.0942 59.4574 51.8714 56.6872L52.3633 56.1915L50.1067 53.917L49.6149 54.4127C47.4452 56.5997 44.5811 57.7953 41.5145 57.7953C38.448 57.7953 35.5839 56.5997 33.4141 54.4127C31.2444 52.2257 30.0583 49.3389 30.0583 46.2479C30.0583 43.1569 31.2444 40.2701 33.4141 38.0831C35.5839 35.8961 38.448 34.7005 41.5145 34.7005C44.5811 34.7005 47.4452 35.8961 49.6149 38.0831C51.4086 39.891 52.5368 42.1655 52.8551 44.6441H50.4539C50.1357 42.807 49.2677 41.1157 47.937 39.7744C46.2301 38.0539 43.9446 37.0917 41.5145 37.0917C39.0844 37.0917 36.7989 38.0539 35.0921 39.7744C33.3852 41.4948 32.4305 43.7985 32.4305 46.2479C32.4305 48.6974 33.3852 51.001 35.0921 52.7214C36.77 54.4127 38.9976 55.375 41.3699 55.4042H41.5145C43.9446 55.4042 46.2301 54.4419 47.937 52.7214L48.4288 52.2257L46.1722 49.9512L45.6804 50.447C44.5522 51.5842 43.0767 52.1966 41.4856 52.1966C39.8945 52.1966 38.419 51.5842 37.2908 50.447C36.5675 49.718 36.0468 48.814 35.7864 47.8226H56.1241V46.073M41.4856 44.6149H35.7864C36.0468 43.6235 36.5675 42.7487 37.2908 42.0197C38.419 40.8825 39.8945 40.2701 41.4856 40.2701C43.0767 40.2701 44.5522 40.8825 45.6804 42.0197C46.4037 42.7487 46.9244 43.6527 47.1848 44.6149H41.4856Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1533">
          <rect width="83" height="92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
